import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import OndemandVideoOutlined from '@mui/icons-material/OndemandVideoOutlined';
import PhoneIphone from '@mui/icons-material/PhoneIphone';

import ShareResourceBanner from '~components/ShareResourceBanner/ShareResourceBanner';
import { ShareResourceBannerConfig } from '~components/ShareResourceBanner/shareResourceBannerTypes';

import {
  DRIVER_APP_LINK,
  DRIVER_FULL_TRAINING,
  DRIVER_QUICK_START,
  DRIVER_TRAINING_VIDEO,
} from './driverAppShareLinks';

const DRIVER_APP_SHARE_CONFIG: ShareResourceBannerConfig = {
  testIdPrefix: 'driver-app-share',
  Icon: PhoneIphone,
  primaryLink: DRIVER_APP_LINK,
  translationNamespace: 'administration.driver_app_share',
  steps: [
    {
      titleKey: 'administration.driver_app_share.steps.step_1_title',
      subtitleKey: 'administration.driver_app_share.steps.step_1_subtitle',
    },
    {
      titleKey: 'administration.driver_app_share.steps.step_2_title',
      subtitleKey: 'administration.driver_app_share.steps.step_2_subtitle',
    },
    {
      titleKey: 'administration.driver_app_share.steps.step_3_title',
      subtitleKey: 'administration.driver_app_share.steps.step_3_subtitle',
    },
  ],
  aside: {
    kind: 'guides',
    items: [
      {
        Icon: OndemandVideoOutlined,
        titleKey: 'administration.driver_app_share.guides.video_title',
        href: DRIVER_TRAINING_VIDEO,
      },
      {
        Icon: MenuBookOutlined,
        titleKey: 'administration.driver_app_share.guides.quick_start_title',
        href: DRIVER_QUICK_START,
      },
      {
        Icon: FactCheckOutlined,
        titleKey: 'administration.driver_app_share.guides.full_training_title',
        href: DRIVER_FULL_TRAINING,
      },
    ],
  },
};

// The Drivers page lays out its content without a flex-gap column, so the banner
// keeps its own bottom margin to separate it from the filters below.
const DriverAppShareBanner = () => (
  <ShareResourceBanner config={DRIVER_APP_SHARE_CONFIG} sx={{ mb: 2 }} />
);

export default DriverAppShareBanner;
